import React, { useState } from "react";
import { scaleOrdinal } from "d3";

import "./Legend.scss";

export const colorScale = scaleOrdinal()
  .domain([
    "Israel",
    "Luxembourg",
    "Cayman Islands",
    "British Virgin Islands",
    "UK",
    "USA",
    "Netherlands",
    "Cyprus",
    "Bulgaria",
    "none",
  ])
  .range([
    "rgb(15,3,198)",
    "rgb(217,114,168)",
    "rgb(41,48,98)",
    "rgb(41,48,98)",
    "rgb(41,48,98)",
    "#ff0000",
    "rgb(234,151,54)",
    "rgb(80,90,51)",
    "rgb(8,138,98)",
    "#fff",
  ]);

export const Legend = ({ visible = false, className = "" }) => {
  const [isOpen, setIsOpen] = useState(visible);

  return (
    <div
      className={`legend pointer ml2 mt1 rounded-md p1 block-font border border-white ${className}`}
    >
      <div
        className="flex flex-row flex-wrap justify-between items-center h4"
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        <div className="prompt bold">{!isOpen ? `Show` : `Hide`} Legend</div>
        <div>
          <svg
            className={`expand ${isOpen ? `expand--open` : ``}`}
            role="img"
            aria-label="expand card-stack"
          >
            <use xlinkHref="#chevron-down" />"
          </svg>
        </div>
      </div>
      <div className="no-pointer-events">
        {isOpen && (
          <>
            <hr />
            <div className="fade-in mt1 mb1 ml1 flex flex-column h4">
              <div className="bold mb1">Incorporated In</div>
              <div className="flex flex-column flex-wrap">
                {colorScale
                  .domain()
                  .slice(0, -1)
                  .map((c) => (
                    <div className="mb1 flex flex-row items-center">
                      <div
                        className="indicator"
                        style={{ backgroundColor: colorScale(c) }}
                      />
                      <div>{c}</div>
                    </div>
                  ))}
              </div>
            </div>
          </>
        )}
        {isOpen && (
          <>
            <hr />
            <div className="fade-in ml1 flex flex-column h4">
              <div className="bold mb1">Type of Entity</div>
              <div className="flex flex-column flex-wrap">
                <div className="mb1 flex flex-row items-center">
                  <div className="indicator" />
                  <div>Company</div>
                </div>
                <div className="mr2 flex flex-row items-center">
                  <div className="indicator indicator--rectangle" />
                  <div>Individual</div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
